/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TrackElementWrite
 */
export interface TrackElementWrite {
    /**
     * 
     * @type {string}
     * @memberof TrackElementWrite
     */
    parentTrackId: string;
}

/**
 * Check if a given object implements the TrackElementWrite interface.
 */
export function instanceOfTrackElementWrite(value: object): value is TrackElementWrite {
    let isInstance = true;
    isInstance = isInstance && "parentTrackId" in value && value["parentTrackId"] !== undefined;

    return isInstance;
}

export function TrackElementWriteFromJSON(json: any): TrackElementWrite {
    return TrackElementWriteFromJSONTyped(json, false);
}

export function TrackElementWriteFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackElementWrite {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'parentTrackId': json['parent_track_id'],
    };
}

export function TrackElementWriteToJSON(value?: TrackElementWrite | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'parent_track_id': value.parentTrackId,
    };
}

